import type { IncomingInvoiceCostAllocationFormSchema } from "@msuite/utils/schemas";

/** The allocation form's values — see `incomingInvoiceCostAllocationFormSchema`. */
export type CostAllocationFormValues = IncomingInvoiceCostAllocationFormSchema;

/**
 * A row's share of the net amount, in percent with two decimals.
 *
 * @param amount - The row's amount.
 * @param netAmount - The invoice's net amount.
 */
export function shareOf(amount: number, netAmount: number) {
	return netAmount ? Math.round((amount / netAmount) * 10000) / 100 : 0;
}

/**
 * The amount a share of the net amount comes to, to the cent.
 *
 * @param share - The share in percent.
 * @param netAmount - The invoice's net amount.
 */
export function amountOf(share: number, netAmount: number) {
	return Math.round(netAmount * share) / 100;
}
